/**
 * Escape text for use inside an HTML string. Provider names, event titles and addresses come from staff today and
 * from crawled data (OSM, Overture, venue websites) once locations can be onboarded (conductor-server #248), and some
 * of them are rendered through [innerHTML] (the transfer picker's options and address cards). Escape every value
 * interpolated into such a string; only the markup we write ourselves (<strong>, <br />) should remain.
 */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
